<div class="border-grey-light header-container">
  <div class="row gap-22 mobile-row">
    <div class="col-md col-2 col-xs-4 border-blue"></div>

    <div class="col-md col-2 col-xs-4 border-blue"></div>

    <div class="col-md col-2 col-xs-4 border-blue"></div>

    <div class="col-md col-2 col-xs-4 border-grey"></div>
  </div>

  <div class="row d-flex justify-content-end mg-top-8">
    <p>Passo 3 de 4</p>
  </div>
  <h5 class="mg-top-16 mg-bottom-16">Confirmação dos dados cadastrais</h5>
  <p class="p-text-grey mg-bottom-32">
    Revise e confirme se os dados complementares estão corretos e atualizados.
  </p>
</div>
 
<div class="padding-16">
  <div class="row mg-bottom-16">
    <h6>Dados bancários</h6>
  </div>

  <div class="row d-flex justify-content-between">
    <p class="p-text-grey">Informe os dados bancários da empresa</p>
    <p class="p-text-grey">* Campos obrigatórios</p>
  </div>
</div>
<form [formGroup]="accountForm">
  <div class="row">
    <div class="col-md-4">

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Banco</mat-label>
        <mat-select (selectionChange)="changeBank($event)" formControlName="name" required #singleSelect>
          <mat-option>
            <ngx-mat-select-search placeholderLabel="Banco" noEntriesFoundLabel="Nenhum resultado encontrado"
              [formControl]="bankFilterCtrl"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let bank of filteredBanks | async" [value]="bank.name">
            {{ bank.code }} - {{ bank.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="
        accountFormControl.name.touched &&
        accountFormControl.name.errors?.required
      ">
          Banco obrigatório</mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Agência</mat-label>
        <input matInput formControlName="agency" type="text" class="" name="agency" required />
        <mat-error *ngIf="
            accountFormControl.agency.touched &&
            accountFormControl.agency.errors?.required
          ">
          Agência obrigatória</mat-error>
          <mat-error *ngIf="accountFormControl.agency.touched &&
          accountFormControl?.agency.hasError('pattern')">A agência deve conter apenas números</mat-error>

      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Conta com dígito</mat-label>
        <input matInput formControlName="number" type="text" class="" name="number" required />
        <mat-error *ngIf="
            accountFormControl.number.touched &&
            accountFormControl.number.errors?.required
          ">
          Conta com dígito obrigatória</mat-error>
      </mat-form-field>
    </div>
  </div>
</form>

<div class="row d-flex justify-content-between padding-bottom-32 pt-2 border-grey-light buttons">
  <button id="btn-primary-return" class="btn btn-block btn-outline-primary" type="button" (click)="goBack()">
    Voltar
  </button>

  <button [style.width]="'auto'" [disabled]="accountForm.invalid || loading" class="btn btn-dark-primary-blue"
    type="button" (click)="sendAccountInbound()">
    Avançar
    <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
  </button>
</div>